jQuery.validator.addMethod('ukPhone', function (value) {
  // Accept: +44..., 0044..., or 0... with 9-10 digits after the prefix
  return this.optional(arguments[1]) || /^(\+44|0044|0)[1-9][0-9]{9}$/.test(value.replace(/[\s\-()]/g, ''))
}, 'Please enter a valid UK phone number')

jQuery(document).ready(function ($) {
  $eventStartInput = $('[name="contact[event_start]"]');
  if ($eventStartInput.length) {
    new Pikaday({ field: $eventStartInput[0] });
  }
  $eventEndInput = $('[name="contact[event_end]"]');
  if ($eventEndInput.length) {
    new Pikaday({ field: $eventEndInput[0] });
  }

  $(".jevents-enquiry #ContactForm").validate({
    errorClass: "is-invalid",
    rules: {
      // Event details
      "contact[event_start]": "required",
      "contact[event_end]": "required",
      "contact[venue_name]": "required",
      "contact[venue_addr_line1]": "required",
      "contact[access_time]": "required",
      "contact[exit_time]": "required",
      // "contact[venue_addr_line2]": "required",
      "contact[venue_addr_town]": "required",
      "contact[venue_postcode]": "required",
      // User details
      "contact[name]": "required",
      "contact[email]": "required",
      "contact[phone]": {
        required: true,
        ukPhone: true,
      },
      "contact[email]": {
        required: true,
        email: true,
      },
    },
    messages: {
      // Event details
      "contact[access_time]": "This is required",
      "contact[exit_time]": "This is required",
      "contact[event_start]": "This is required",
      "contact[event_start_end]": "This is required",
      "contact[event_end]": "This is required",
      "contact[event_end_end]": "This is required",
      "contact[venue_name]": "This is required",
      "contact[venue_addr_line1]": "This is required",
      "contact[venue_addr_line2]": "This is required",
      "contact[venue_addr_town]": "This is required",
      "contact[venue_postcode]": "This is required",
      // User details
      "contact[name]": "This is required",
      "contact[email]": "This is required",
      "contact[phone]": "This is required",
      "contact[email]": "This is required",
    },
    errorElement: "div",
    errorPlacement: function (error, element) {
      error.addClass("invalid-feedback");
      if (element.prop("type") === "checkbox") {
        error.insertAfter(element.parent("label"));
      } else {
        error.insertAfter(element);
      }
    },
    highlight: function (element, errorClass, validClass) {
      $(element).addClass(errorClass).removeClass(validClass);
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).addClass(validClass).removeClass(errorClass);
    },
  });

  function ajax(options) {
    return new Promise(function (resolve, reject) {
      $.ajax(options).done(resolve).fail(reject);
    });
  }

  /**
   * The main button
   */
  $button = $(".jevents-enquiry #ContactForm input[type='button']");

  /**
   * On click, get the data, send to the server and redirect the user
   * TODO: Some kind of loading state
   * TODO: Hide the Google Pay Button
   * TODO: Rename buttons "Add to enquiry"
   */
  $button.click(function (event) {
$("#ContactForm").validate()
  var valid = $("#ContactForm").valid()
    if (!valid){
      return;
    }
    
    event.preventDefault();
    $(".jevents-loader").show();
    return ajax({
      type: "GET",
      url: "/cart.js",
      dataType: "json",
    })
      .then(function (items) {
        var customData = {};
        $(".form-control").each(function () {
          var value = $(this).val();
          var key = $(this)
            .attr("name")
            .replace("contact[", "")
            .replace("]", "");
          customData[key] = value;
        });

        var data = Object.assign({}, items, { custom_attributes: customData });

        return ajax({
             type: "POST",
           url: "https://jevents-api.jevents.workers.dev/send-enqiry",
             data: JSON.stringify(data),
             dataType: "json",
             contentType: "application/json",
           });
      })
      .then(function (data) {
         return ajax({
           url: "/cart/clear.js",
         }).catch((e) => {
           if (e.status === 200) {
             return Promise.resolve();
           }
           return Promise.reject();
         });
      })
      .then(function () {
        window.location = "/pages/thanks";
      })
      .catch(function (e) {
        console.log("e", e);
        $(".jevents-loader").hide();
        alert(
          "Sorry, there has been an error - Try again, or please contact us"
        );
      });
  });
});
